module.exports = __webpack_public_path__ + "img/klcx_05.da25720e.jpg";